import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-campo',
  templateUrl: './campo.component.html',
  styleUrls: ['./campo.component.css']
})
export class CampoComponent implements OnInit {

  @Input() desabilitarAutoFill: boolean = false;
  @Input() formulario: UntypedFormGroup;
  @Input() name: string;
  @Input() descricao: string = '';
  @Input() tipo: string = 'text';
  @Input() modoInsercao: string = 'text';
  @Input() nomeControle: string;
  @Input() autoPreenchimento: string;
  @Input() identificacao: string;
  @Input() textoAjuda: string;
  @Input() mascara: string = null;
  @Input() classe: string;
  @Input() botaoAcao: boolean = false;

  @Output() alteracao = new EventEmitter();
  @Output() quandoEstiverNoCampo = new EventEmitter();

  constructor() { }

  handleAutoFill(evt) {
    if (evt.isAutofilled && this.desabilitarAutoFill) {
        this.formulario.controls[this.nomeControle].setValue('');
    }
  }

  ngOnInit(): void { }

  change() {
    this.alteracao.emit();
  }

  focus() {
    this.quandoEstiverNoCampo.emit();
  }

}
